import React, {useState} from 'react';
import {Icon} from '@iconify/react';
import {useSelector} from 'react-redux';
import DrawerMenu from '../../../../../incase-domain/components/drawerMenu/DrawerMenu';
import {loggedInUserSelector} from '../../../../../store/selectors/auth.selectors';
import Button from '../../../../../incase-domain/components/button/Button';

interface menuItem {
    name: string;
    items: {callback: () => void; disabled?: boolean; icon: string; label: string}[];
}

interface MobileHeaderIconsProps {
    showProfile?: boolean;
    menuItems: menuItem[];
}

function MobileHeader({showProfile, menuItems}: MobileHeaderIconsProps): JSX.Element {
    const [openDrawer, setOpenDrawer] = useState(false);

    const loggedInUser = useSelector(loggedInUserSelector);

    return (
        <div className="c-headerMenuWrapper">
            <Button leading="ph:list" square variant="ghost" onClick={() => setOpenDrawer(true)} />

            <DrawerMenu open={openDrawer} setOpen={setOpenDrawer}>
                <div className="c-headerMenu">
                    {showProfile && (
                        <div className="c-headerMenu__profile">
                            <Icon icon="ph:user-circle-fill" className="c-headerMenu__profile_avatar" />

                            <div className="c-headerMenu__profile_name">{loggedInUser?.username}</div>
                            <div className="c-headerMenu__profile_email">{loggedInUser?.email}</div>
                        </div>
                    )}

                    {menuItems.map((menuItem) => (
                        <div className="c-headerMenu__group">
                            <div className="c-headerMenu__group_title">{menuItem.name}</div>
                            {menuItem.items.map((item) => (
                                <Button
                                    leading={item.icon}
                                    onClick={item.callback}
                                    disabled={item.disabled}
                                    variant="ghost"
                                    size="sm"
                                    fullWidth
                                >
                                    {item.label}
                                </Button>
                            ))}
                        </div>
                    ))}
                </div>
            </DrawerMenu>
        </div>
    );
}

export default MobileHeader;
